import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "brand",
  listKey: "brands",
  itemKey: "brand",
  getAll: types.GET_ALL_BRANDS,
  getAllResponse: types.GET_ALL_BRANDS_RESPONSE,
  getByIdResponse: types.GET_BRAND_BY_ID_RESPONSE,
  extra: {
    profile: { type: types.GET_BRAND_PROFILE_RESPONSE, initial: null },
    dashboard: { type: types.GET_BRAND_DASHBOARD_RESPONSE, initial: null },
  },
});
